import { ReachInfoModel } from "./ReachInfoModel";

export class VisitorAuthenticationModel{
    IDNumber!:string;
    ReachInfo!:ReachInfoModel;
}